import React, { useState, useEffect, useLayoutEffect } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import styles from "./header.module.css";

const MenuMobile = dynamic(() => import("./MenuMobile"), {
  ssr: false,
});
const SearchPropriety = dynamic(() => import("./SearchPropriety"), {
  ssr: false,
});
const ContactBox = dynamic(() => import("./ContactBox"), {
  ssr: false,
});
const Chevron = dynamic(() => import("./Chevron"), {
  ssr: false,
});

export default function Header({ data }) {
  const [boxActive, setBoxActive] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [windowWidth, setWindowWidth] = useState(null);
  const [slidingMenu, setSlidingMenu] = useState(false);

  const slideMenu = () => {
    return slidingMenu ? { width: "271px" } : { marginRight: "-1000px" };
  };

  const menuButtonCliked = () => {
    setSlidingMenu(!slidingMenu);
  };

  useLayoutEffect(() => {
    function handleResize() {
      setWindowWidth(window.outerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function handleChevron() {
    setBoxActive(!boxActive);
    setSearchActive(false);
  }

  function handleSearch() {
    setBoxActive(false);
    setSearchActive(!searchActive);
  }

  return (
    <>
      <div className={`${styles.container} container-full`}>
        <div className="container-geral justify-content-between">
          <div className={styles.logo}>
            <Link href="/">
              <a>
                <img
                  src={data.logo.url}
                  width={data.logo.width}
                  height={data.logo.height}
                  alt="Realiza logo"
                />
              </a>
            </Link>
          </div>
          {windowWidth <= 1180 ? (
            <>
              <div className={styles.searchPortal}>
                <div className={styles.search} onClick={handleSearch}>
                  <img
                    src="/icons/lupa.svg"
                    alt="search"
                    width={16}
                    height={16}
                  />
                </div>
                <div className={styles.portal}>
                  <a href="https://portaldocliente.expertsystem.com.br/entrar/Realiza">
                    <img
                      src="/icons/person_portal.svg"
                      alt="person"
                      width={19}
                      height={19}
                    />
                  </a>
                </div>
                <div
                  className={styles.menu}
                  onClick={() => {
                    menuButtonCliked();
                  }}
                >
                  <img
                    src="/icons/menu.svg"
                    alt="menu"
                    width={20}
                    height={18}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <nav>
                {data.menu.map((item) => {
                  return (
                    <>
                      <div key={item.id}>
                        <div>
                          <Link href={item.link}>
                            <a>{item.nome}</a>
                          </Link>
                        </div>
                      </div>
                      {item.nome === "Diferenciais" && (
                        <div key={item.id}>
                          <div>
                            <Link href={"/minha-casa-minha-vida"}>
                              <a>Minha Casa Minha Vida</a>
                            </Link>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              </nav>
              <ContactBox boxActive={boxActive} />
              <div className={styles.searchPortal}>
                <div className={styles.search} onClick={handleSearch}>
                  <img src="/icons/lupa.svg" alt="search" />
                </div>
                <div className={styles.portal}>
                  {windowWidth <= 1400 ? (
                    <a href="https://portaldocliente.expertsystem.com.br/entrar/Realiza">
                      <img
                        src="/icons/person_portal.svg"
                        width={19}
                        height={19}
                        alt="person"
                      />
                    </a>
                  ) : (
                    <>
                      <img
                        src="/icons/detail-small.svg"
                        width={25}
                        height={15}
                      />
                      <a href="https://portaldocliente.expertsystem.com.br/entrar/Realiza">
                        portal do cliente
                      </a>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>

        <SearchPropriety searchActive={searchActive} />
        <MenuMobile
          style={slideMenu()}
          data={data.submenus}
          onClick={menuButtonCliked}
        />
      </div>
    </>
  );
}
